import "$styles/index.css";

import { Application } from "@hotwired/stimulus";

const application = Application.start();

// Register Stimulus controllers in frontend/javascript/controllers/
